/**
 * CertificateNotices - Certificate Restriction and Configuration Display Component
 * Extracted from StepVesselIdentity to maintain file size limits
 */

import React from 'react';
import WizardSection from '../../WizardSection';

const CertificateNotices = ({ currentConfig }) => {
  return (
    <>
      {/* Show restrictions for non-workboat certificates */}
      {currentConfig.baseCertificate === 'light_duty_workboat' && (
        <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <span className="text-amber-400">⚠️</span>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-amber-800">Light Duty Certificate Restrictions</h3>
              <div className="mt-1 text-sm text-amber-700">
                <p><strong>WBC3 Section 3.9.3.5:</strong></p>
                <ul className="list-disc list-inside space-y-1 mt-1">
                  <li>❌ NO lifting devices (cranes, davits, hoists)</li>
                  <li>❌ NO standard towing operations</li>
                  <li>❌ NO dangerous goods carriage</li>
                  <li>📦 CARGO limited to 1000kg maximum</li>
                </ul>
                <p className="mt-2 text-xs">
                  These restrictions are legally binding. Endorsements permitted: Pilot Boat, MGO Transfer, High-Speed, Tender Types.
                  <br/><strong>Towing endorsement prohibited per WBC3 3.9.3.5.</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Non-Self-Propelled Platform Notice */}
      {currentConfig.baseCertificate === 'non_self_propelled' && (
        <div className="mt-4 p-3 bg-purple-50 border border-purple-200 rounded-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <span className="text-purple-400">🏗️</span>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-purple-800">Non-Self-Propelled Platform Certificate</h3>
              <div className="mt-1 text-sm text-purple-700">
                <p><strong>WBC3 Section 26.5.1.1:</strong> Unmanned working platform assessed for appropriate WBC3 parts only</p>
                <ul className="list-disc list-inside space-y-1 mt-2">
                  <li>✅ Platform safety equipment (emergency towing, anchoring)</li>
                  <li>✅ Marking and stability requirements</li>
                  <li>❌ NO crew requirements (unmanned operation)</li>
                  <li>❌ NO universal operational requirements</li>
                  <li>❌ NO commercial endorsements (platform-specific only)</li>
                </ul>
                <p className="mt-2 text-xs">
                  <strong>Selective Assessment:</strong> Only platform-specific safety requirements apply per WBC3 26.5 framework.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Other Certificate Notices */}
      {(currentConfig.baseCertificate === 'pilot_boat_dedicated' || 
        currentConfig.baseCertificate === 'police_boat') && (
        <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <span className="text-blue-400">ℹ️</span>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-blue-800">Certificate Notice</h3>
              <p className="mt-1 text-sm text-blue-700">
                This certificate type has specific operational authorities and does not require additional commercial endorsements.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Show current certificate summary */}
      <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-md">
        <h4 className="text-sm font-medium text-gray-900">Selected Certificate Configuration:</h4>
        <div className="mt-2 text-sm text-gray-700">
          <strong>Certificate:</strong> {
            currentConfig.baseCertificate === 'workboat' && currentConfig.endorsements.length === 0 ? 'Standard Workboat Certificate' :
            currentConfig.baseCertificate === 'workboat' && currentConfig.endorsements.length === 1 ? `Workboat Certificate with ${
              currentConfig.endorsements[0] === 'towing' ? 'Towing' :
              currentConfig.endorsements[0] === 'pilot_boat' ? 'Pilot Boat' :
              currentConfig.endorsements[0] === 'mgo_transfer' ? 'MGO Transfer' :
              currentConfig.endorsements[0] === 'high_speed' ? 'High-Speed' :
              'Unknown Endorsement'
            } Endorsement` :
            currentConfig.baseCertificate === 'workboat' && currentConfig.endorsements.length > 1 ? `Workboat Certificate with Multiple Endorsements (${currentConfig.endorsements.length})` :
            currentConfig.baseCertificate === 'light_duty_workboat' ? 'Light Duty Workboat Certificate' :
            currentConfig.baseCertificate === 'pilot_boat_dedicated' ? 'Dedicated Pilot Boat Certificate' :
            currentConfig.baseCertificate === 'police_boat' ? 'Police Boat Certificate (WBC3 Annex 3)' :
            currentConfig.baseCertificate === 'non_self_propelled' ? 'Non-Self-Propelled Workboat Certificate (Platform)' :
            'Standard Workboat Certificate'
          }
          {currentConfig.endorsements.length > 0 && (
            <div className="mt-1">
              <strong>Endorsements:</strong> {currentConfig.endorsements.map(e => 
                e === 'towing' ? 'Towing' :
                e === 'pilot_boat' ? 'Pilot Boat' :
                e === 'mgo_transfer' ? 'MGO Transfer' :
                e === 'high_speed' ? 'High-Speed' :
                'Unknown Endorsement'
              ).join(', ')}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CertificateNotices;